export const BASE_URL = 'https://react-quiz-6c8b7.firebaseio.com'

export const AUTH_BASE_URL = 'https://identitytoolkit.googleapis.com/v1/accounts'
export const AUTH_KEY = 'AIzaSyAAqVoCEcf2Bqk4o9e_DkPcaOv5bhQn68g'
export const AUTH_SIGN_UP = 'signUp'
export const AUTH_SIGN_IN_WITH_PASSWORD = 'signInWithPassword'